import React from 'react';
import styles from './index.module.scss';

const AgeGateScreen = ({ onConfirm, onDecline }) => {
  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <p className={styles.lead}>
          Сайт містить
          <br /> контент тільки для
          <br /> користувачів, які досягли
          <br /> повноліття
        </p>
        <p className={styles.question}>Чи досягли ви повноліття?</p>
        <div className={styles.actions}>
          <button type="button" className={styles.choice} onClick={onConfirm}>
            Так
          </button>
          <button type="button" className={styles.choice} onClick={onDecline}>
            Ні
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGateScreen;
